import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ArquivoScr } from './arquivo-src.model';
import { BaseModel } from './base-model.model';
import { Estado } from './estado.model';
import { OperacaoScr } from './operacao-scr.model';

export class SolicitacaoHonra extends BaseModel {
	public cnpjAgenteFinanceiro: string;
	public idOperacaoExterno: string;
	public sistemaRepasse: string;
	public contratoRepasse: number;
	public nomeJanela: string;
	public estado: Estado;
	public dataParcelaInicialInadimplente: Date;
	public dataParcelaInicialASerHonrada: Date;
	public valorEstimadoHonra: number;
	public dataEstimativaHonra: Date;
	public dataEnvio: Date;
	public detalhe: DetalheSolicitacaoHonra;
  	public cestaNumero: number;
	public numeroProcesso: string;
	public dataInicioInadimplencia: Date;

	private _prioridadeOriginal: number; // transiente usado em telas (ex: cadastro de SH)
	get prioridadeOriginal() { return this._prioridadeOriginal};
	set prioridadeOriginal(prioridade: number) { this._prioridadeOriginal = prioridade};
	private _prioridadeNova: number; // transiente usado em telas (ex: cadastro de SH)
	get prioridadeNova() { return this._prioridadeNova};
	set prioridadeNova(prioridade: number) { this._prioridadeNova = prioridade};
}

export class DetalheSolicitacaoHonra {
	public valorSaldoDevedorDePrincipal: number;
	public valorSaldoDeJurosNaNormalidade: number;
	public valorSaldoDeEncargosMoratorios: number;
	public comLimite: boolean;
	public recebimentosParciaisDePrincipal: RecebimentoParcialPrincipal[];
	public informeRecebimentosParciaisDePrincipal: RecebimentoParcialPrincipal[];
	public historicoEstados: HistoricoEstadoSolicitacaoHonra[];
	public arquivosScrUtilizadosNaValidacao:SolicitacaoHonraArquivoSCR[];
	public indicadorRemunerarSolicitacaoHonra: boolean;
}

export class SolicitacaoHonraArquivoSCR{
	public arquivoScrUtilizadoNaValidacao:ArquivoScr;
	public operacaoScrUtilizadaNaValidacao:OperacaoScr;
	public dataValidacao:string;
	public tipoValidacao:string;
	public trocaIpoc:boolean;
    public ipocNovo:string;
}

export class HistoricoEstadoSolicitacaoHonra {
    public id: number;
	public dataUltimaAtualizacao: Date;
	public estado: Estado;
	public nomeUsuarioResponsavel: string;
}

export class RecebimentoParcialPrincipal {
	public dataPrestacao: string;
	public valorRecebido: string;
	public valorDevido: string;
}

export class SolicitacaoHonraEnvio {
	public idOperacaoAgenteCreditoLivre: string;
	public sistemaRepasse: string;
	public contratoRepasse: string;
	public valorSaldoDevedorDePrincipal: number;
	public valorSaldoDeJurosNaNormalidade: number;
	public valorEncargosMoratorios: number;
	public amortizacoesAteADataDaSolicitacaoDeHonra: AmortizacaoEnvio[];
	public valoresRecebidos: ValorRecebido[];
	public dataInicioInadimplencia: Date;
  public possuiBloqueioJudicial: string;
  public numeroProcesso: string;
}

export class AmortizacaoEnvio {
	public dataVencimento: Date;
	public valorDevido: number;
	public valorRecebido: number;
}

export class ValorRecebido {
	public dataRecebimento: Date;
	public valorRecebido: number;
}

export class ControleFaturaHonra {
	public usuarioFaturaCreditoLivre: string;
    public usuarioFaturaRepasseBndes: string;
}

export class SolicitacaoHonraExportacao extends SolicitacaoHonra {
	public processamentoNumeroContrato: string;
    public processamentoFaturaCreditoLivre: string;
    public processamentoFaturaRepasseParcelasVencidas: string;
    public processamentoFaturaRepasseParcelasVincendas: string;
}

// JSON de exemplo de solicitação de honra para exportação de arquivo de exemplo

export const solicitacaoHonraExemplo =
`
{
	"cnpjAgenteFinanceiro": "58017179000170",
	"solicitacoesHonra": [
		{
			"idOperacaoAgenteCreditoLivre": "OPE-CL-TESTE-1",
			"valorSaldoDevedorDePrincipal": 3228979.93,
			"valorSaldoDeJurosNaNormalidade": 1000,
			"valorEncargosMoratorios": 100,
			"amortizacoesAteADataDaSolicitacaoDeHonra": [
				{
					"dataVencimento": "2020-08-31",
					"valorDevido": 9964759.93,
					"valorRecebido": 6735800
				},
				{
					"dataVencimento": "2021-02-28",
					"valorDevido": 10,
					"valorRecebido": 0
				}
			],
      "possuiBloqueioJudicial": "S",
      "numeroProcesso": "0021781-27.2020.8.19.0208"
		},
		{
			"sistemaRepasse": "89",
			"contratoRepasse": "22222222222",
			"valorSaldoDevedorDePrincipal": 3228979.93,
			"valorSaldoDeJurosNaNormalidade": 1000,
			"valorEncargosMoratorios": 100,
			"amortizacoesAteADataDaSolicitacaoDeHonra": [
				{
					"dataVencimento": "2020-08-31",
					"valorDevido": 9964759.93,
					"valorRecebido": 6735800
				},
				{
					"dataVencimento": "2021-02-28",
					"valorDevido": 10,
					"valorRecebido": 0
				}
			],
      "possuiBloqueioJudicial": "N"
		},
		{
			"sistemaRepasse": "89",
			"contratoRepasse": "33333333333",
			"valorSaldoDevedorDePrincipal": 3228979.93,
			"valorSaldoDeJurosNaNormalidade": 1000,
			"valorEncargosMoratorios": 100,
			"amortizacoesAteADataDaSolicitacaoDeHonra": [
				{
					"dataVencimento": "2020-08-31",
					"valorDevido": 9964759.93,
					"valorRecebido": 6735800
				},
				{
					"dataVencimento": "2021-02-28",
					"valorDevido": 10,
					"valorRecebido": 0
				}
			]
		},
    {
			"sistemaRepasse": "89",
			"contratoRepasse": "44444444444",
			"valorSaldoDevedorDePrincipal": 3228979.93,
			"valorSaldoDeJurosNaNormalidade": 1000,
			"valorEncargosMoratorios": 100,
			"amortizacoesAteADataDaSolicitacaoDeHonra": [
				{"dataVencimento":"2023-12-15","valorDevido":2729.57},
        {"dataVencimento":"2024-01-15","valorDevido":2900.77},
        {"dataVencimento":"2024-02-15","valorDevido":2677.25},
        {"dataVencimento":"2024-03-15","valorDevido":2677.25}
			],
      "dataInicioInadimplencia": "2024-01-15",
      "valoresRecebidos": [
        {
          "dataRecebimento": "2024-01-15",
          "valorRecebido": 1000.00
        },
        {
          "dataRecebimento": "2024-02-20",
          "valorRecebido ": 500.00
        }
      ]
		}
	]
}
`;

export const solicitacaoHonraExemploFGT =
`
{
	"cnpjAgenteFinanceiro": "58017179000170",
    "solicitacoesHonra": [
        {
            "idOperacaoAgenteCreditoLivre": "OPE-CL-TESTE-1",
            "valorSaldoDevedorDePrincipal": 100000.00,
            "valorSaldoDeJurosNaNormalidade": 1000,
            "valorEncargosMoratorios": 100,
            "amortizacoesAteADataDaSolicitacaoDeHonra": [
                {
                    "dataVencimento": "2020-08-10",
                    "valorDevido": 5000
                },
                {
                    "dataVencimento": "2020-09-10",
                    "valorDevido": 5000
                },
                {
                    "dataVencimento": "2020-10-10",
                    "valorDevido": 5000
                }
            ],
            "dataInicioInadimplencia": "2020-08-10",
            "valoresRecebidos": [
                {
                    "dataRecebimento": "2020-08-10",
                    "valorRecebido": 1000
                 }
            ],
            "possuiBloqueioJudicial": "S",
            "numeroProcesso": "0021781-27.2020.8.19.0208"
        },
        {
            "sistemaRepasse": "89",
            "contratoRepasse": "44444444444",
            "valorSaldoDevedorDePrincipal": 3228979.93,
            "valorSaldoDeJurosNaNormalidade": 1000,
            "valorEncargosMoratorios": 100,
            "amortizacoesAteADataDaSolicitacaoDeHonra": [
                {
                    "dataVencimento": "2023-12-15",
                    "valorDevido": 2729.57
                },
                {
                    "dataVencimento": "2024-01-15",
                    "valorDevido": 2900.77
                },
                {
                    "dataVencimento": "2024-02-15",
                    "valorDevido": 2677.25
                },
                {
                    "dataVencimento": "2024-03-15",
                    "valorDevido": 2677.25
                }
            ],
            "dataInicioInadimplencia": "2024-01-15",
            "valoresRecebidos": [
                {
                    "dataRecebimento": "2024-01-15",
                    "valorRecebido": 1000
                },
                {
                    "dataRecebimento": "2024-02-20",
                    "valorRecebido ": 500
                }
            ]
        }
    ]
}
`;
